import styled from 'styled-components'
import { PocTaboolaPageType, PocTaboolaSuffixId, Taboola } from '../Taboola'

export const TaboolaWrapper = styled.div`
  position: relative;
  margin-bottom: 15px;
`
const TaboolaWidget = ({
  index = 1,
  taboolaType,
}: {
  index: number
  taboolaType:
    | PocTaboolaPageType.home
    | PocTaboolaPageType.category
    | PocTaboolaPageType.news_hp
}) => {
  return (
    <TaboolaWrapper key={`TaboolaWrapper_${index}`} className='taboola_widget'>
      <Taboola
        pageType={taboolaType}
        key={`t${index}${taboolaType}`}
        suffixId={PocTaboolaSuffixId.widget}
        index={index}
      />
    </TaboolaWrapper>
  )
}
export default TaboolaWidget
